<!-- 教育局-首页概览 -->
<template>
  <div class="home">
    <div class="homes" v-show="!isDetail">
    <div class="header-item-title" v-if="org_type == '1'">
      <select-control class="select_control" @selectOk="selectOk" ref='selectChild' :params='selecTopParams'></select-control>
      <div class="time">
        <span
          >截止日期:{{
            dayjs(new Date().getTime() - 86400000).format("YYYY-MM-DD")
          }}</span
        >
      </div>
    </div>
    <div class="parts">
      <div class="parts-top">
        <!-- 区分教育局端和学校端 -->
        <span class="parts-top_title">
          {{ org_type == '2' ? '课后服务开展情况' : '学校参与情况' }}
        </span>
        <img slot="reference" src="../../assets/img/home_1.svg" alt="" @click="redClick('学校参与情况说明', org_type)"/>
        <el-button class="see_info" @click="seeInfo('afterClassDetail',org_type == '2' ? '课后服务开展情况' : '学校参与情况')" type="text"
          >查看明细</el-button
        >
      </div>
      <div class="parts-content-box">
        <div class="parts-content" v-if="org_type != '2' && !isSchool">
          <div class="conent_title">
            <img src="../../assets/img/home_2.svg" alt="" />
            <span> 提供课后服务学校 </span>
          </div>
          <div class="conent_box">
            <div class="conent_box_text">
              <div>{{isTestUser?62: sch_sup }}</div>
              <p>数量</p>
            </div>
            <el-progress
              class="circle_1"
              type="circle"
              :percentage="isTestUser?84.93:sch_sup_per.toFixed(2)"
              :stroke-width="strokeWidth"
            ></el-progress>
            <!-- <p class="circle_pro" style="top: 45%">{{ sch_sup }}{{ org_type == '2' || isSchool ? '个' : '所' }}</p> -->
            <p class="circle_text">占比</p>
          </div>
        </div>
        <div
          class="parts-content"
          :style="{
            margin: org_type == '1' && !isSchool ? '0 3%' : '0 3% 0 0',
            width: org_type == '1' && !isSchool ? '33%' : '50%',
          }"
        >
          <div class="conent_title">
            <img src="../../assets/img/home_2.svg" alt="" />
            <span> 服务时间(5+2){{ org_type == '2' || isSchool ? '达标班级' : '达标学校' }} </span>
          </div>
          <div class="conent_box">
            <div class="conent_box_text">
              <div>{{ isTestUser?8:sch_time_std }}</div>
              <p>数量</p>
            </div>
            <el-progress
              class="circle_1"
              type="circle"
              :percentage="isTestUser?9.24:sch_time_std_per.toFixed(2)"
              :stroke-width="strokeWidth"
            ></el-progress>
            <!-- <p
              class="circle_pro"
              :style="{ left: org_type == '1' && !isSchool ? '11%' : '7%' }"
            >
              {{ sch_time_std }}{{ org_type == '2' || isSchool ? '个' : '所' }}
            </p> -->
            <p class="circle_text" :style="org_type == '2' || isSchool ?'left:67%':''">占比</p>
          </div>
        </div>
        <div
          class="parts-content"
          :style="{ width: org_type == '1' && !isSchool ? '33%' : '50%' }"
        >
          <div class="conent_title">
            <img src="../../assets/img/home_2.svg" alt="" />
            <span> 课程安排(1+X){{ org_type == '2' || isSchool ? '达标班级' : '达标学校' }} </span>
          </div>
          <div class="conent_box">
            <div class="conent_box_text">
              <div>{{ isTestUser?3:sch_course_std }}</div>
              <p>数量</p>
            </div>
            <el-progress
              class="circle_1"
              type="circle"
              :percentage="isTestUser?4.86:sch_course_std_per.toFixed(2)"
              :stroke-width="strokeWidth"
            ></el-progress>
            <!-- <p
              class="circle_pro"
              :style="{ left: org_type == '1' && !isSchool ? '11%' : '7%' }"
            >
              {{ sch_course_std }}{{ org_type == '2' || isSchool ? '个' : '所' }}
            </p> -->
            <p class="circle_text" :style="org_type == '2' || isSchool ?'left:67%':''">占比</p>
          </div>
        </div>
      </div>
    </div>
    <div class="parts">
      <div class="parts-top">
        <span class="parts-top_title"> 师生出勤情况 </span>
        <img slot="reference" src="../../assets/img/home_1.svg" alt="" @click="redClick('师生出勤率情况说明')" />
        <div class="tab_select">
          <div
            v-for="(item, index) in tabtList_1"
            :class="['res-tab', { on: item.val === tabVal_1 }]"
            :key="index + 'tsTab'"
            @click="tabClick_1(item)"
          >
            {{ item.lable }}
          </div>
        </div>
        <el-button class="see_info" @click="seeInfo('getTeacherAttendance','师生出勤情况')" type="text"
          >查看明细</el-button
        >
      </div>
      <div class="parts-content-box">
        <div class="parts-content-item" style="margin-right: 3%">
          <div class="parts-content-item-left">
            <p>
              {{isTestUser?"59.84%":
                (teacherAttendanceList[0].tea_attendance_per * 100).toFixed(2) *
                  1 +
                "%"
              }}
            </p>
            <p>教师出勤率</p>
          </div>
          <div class="parts-content-item-right" id="chartDom1"></div>
        </div>
        <div class="parts-content-item">
          <div class="parts-content-item-left">
            <p>
              {{ isTestUser?"51.78%":
                (teacherAttendanceList[0].stu_attendance_per * 100).toFixed(2) *
                  1 +
                "%"
              }}
            </p>
            <p>学生出勤率</p>
          </div>
          <div class="parts-content-item-right" id="chartDom2"></div>
        </div>
      </div>
    </div>
    <div class="parts">
      <div class="parts-top">
        <span class="parts-top_title"> 教师参与情况 </span>
        <img slot="reference" src="../../assets/img/home_1.svg" alt="" @click="redClick('教师参与情况说明')" />
        <el-button class="see_info" @click="seeInfo('teacherActor','教师参与情况')" type="text"
          >查看明细</el-button
        >
      </div>
      <div class="parts-content-box">
        <div class="parts-content-left shadow">
          <div class="parts-info-item">
            <p>{{ userInfo.user_id=='fb01b294655e11ecaada0203151a1abe'?28: isTestUser?2667: teacherActorData[0].org_num || 0 }}</p>
            <p>校内教师参与数</p>
          </div>
          <div class="parts-info-item">
            <p>{{isTestUser?3: teacherActorData[0].ext_org_num || 0 }}</p>
            <p>聘用校外教师数</p>
          </div>
          <div class="parts-info-item">
            <p>{{isTestUser?"36.53%": fixed2(teacherActorData[0].org_per || 0) }}</p>
            <p>校内教师参与占比</p>
          </div>
          <div class="parts-info-item">
            <p>{{isTestUser?"10.42%": fixed2(teacherActorData[0].main_per || 0) }}</p>
            <p>校内主科教师参与占比</p>
          </div>
        </div>
        <div class="parts-content-right">
          <p>各类课程教师参与情况</p>
          <div id="chartDom3" style="width: 100%; height: 400px" :style="!teacherYData.length? 'opacity: 0; position: absolute; z-index:0':''"></div>
          <img src="../../assets/img/cloudMap/no_data_bar.svg" style="margin-top:35px; margin-left:100px;" v-if="!teacherYData.length"/> 
        </div>
      </div>
    </div>
    <div class="parts">
      <div class="parts-top">
        <span class="parts-top_title"> 学生参与情况 </span>
        <img slot="reference" src="../../assets/img/home_1.svg" alt="" @click="redClick('学生参与情况说明')" />
        <el-button class="see_info" @click="seeInfo('studentPart','学生参与情况')" type="text"
          >查看明细</el-button
        >
      </div>
      <div class="parts-content-box">
        <div class="parts-content-left">
          <div class="content_box_left">
            <div>
              <p>{{ participate_stu_num }}</p>
              <p>参与课后服务学生数</p>
            </div>
            <div>
              <p>{{ participate_stu_per.toFixed(2) * 1 }}%</p>
              <p>参与课后服务学生占比</p>
            </div>
          </div>
          <div class="content_box_right" style="top: -16%" id="chartDom4"></div>
        </div>
        <div class="parts-content-right">
          <p>各类课程学生参与情况</p>
          <div id="chartDom5" style="width: 100%; height: 400px" :style="!student_participate_num.length? 'opacity: 0; position: absolute; z-index:0':''"></div>
          <img src="../../assets/img/cloudMap/no_data_bar.svg" style="margin-top:35px; margin-left:100px;" v-if="!student_participate_num.length"/> 
        </div>
      </div>
    </div>
    <div class="parts">
      <div class="parts-top">
        <span class="parts-top_title"> 学校开课情况 </span>
        <img slot="reference" src="../../assets/img/home_1.svg" alt="" @click="redClick('学校开课情况说明')" />
        <el-button class="see_info" @click="seeInfo('shoolStartCourse','学校开课情况')" type="text"
          >查看明细</el-button
        >
      </div>
      <div class="parts-content-box">
        <div class="parts-content-left shadow" style="height: 220px">
          <div class="parts-info-item">
            <p>{{ schoolCourseData[0].course_sum }}个</p>
            <p>校内教师课程数</p>
          </div>
          <div class="parts-info-item">
            <p>{{ schoolCourseData[0].course_sum_ext }}个</p>
            <p>校外教师课程数</p>
          </div>
        </div>
        <div class="parts-content-right">
          <div
            id="chartDom6"
            style="width: 100%; height: 220px; right: 30%"
          ></div>
        </div>
      </div>
    </div>
    <div class="parts">
      <div class="parts-top">
        <span class="parts-top_title"> 课程开课情况 </span>
        <img slot="reference" src="../../assets/img/home_1.svg" alt="" @click="redClick('课程开班情况说明')" />
        <!-- <el-button class="see_info" @click="seeInfo('courseStart','课程开课情况')" type="text"
          >查看明细</el-button
        > -->
      </div>
      <div class="parts-content-box">
        <div class="parts-content-left shadow" style="height: 220px">
          <div class="parts-info-item">
            <p>
              {{
                courseStartData.length ? courseStartData[0].class_total : 0
              }}个
            </p>
            <p>课程开班总数</p>
          </div>
          <div class="parts-info-item">
            <p>{{ courseStartData.length }}类</p>
            <p>开设课程类型数</p>
          </div>
        </div>
        <div class="parts-content-right">
          <div
            id="chartDom7"
            style="width: 100%; height: 220px; right: 30%"
          ></div>
        </div>
      </div>
    </div>
    <div class="parts">
      <div class="parts-top">
        <span class="parts-top_title"> 课程评价情况 </span>
        <img slot="reference" src="../../assets/img/home_1.svg" alt="" @click="redClick('课程评价情况说明')" />
        <el-button class="see_info" @click="seeInfo('courseAbnormal','课程评价情况')" type="text"
          >查看明细</el-button
        >
      </div>
      <div class="parts-content-box">
        <div class="echarts_box" style="margin-right:30px">
          <div class="content_echarts_item" id="chartDom8"></div>
        </div>
        <div class="echarts_box">
           <div class="content_echarts_item" id="chartDom10"></div>
        </div>
        <!-- <div class="content_echarts_item" id="chartDom9"></div> -->
        <!-- <div class="content_echarts_item" id="chartDom11"></div> -->
      </div>
    </div>
    <div class="parts">
      <div>
        <span class="warn_title"> 异常评价预警： </span>
        <span
          class="warn_item"
          v-for="(item, index) in tabtList"
          :class="{ on: item.val === tabVal }"
          :key="index + 'ycTab'"
          @click="tabClick(item)"
        >
          {{ item.lable }}
        </span>
      </div>
      <div class="school_list">
        <!-- <span v-for="(item, index) in warningSchoolList" :key="index">
          {{ `${item.name} (${item.time}次)` }}
        </span> -->
        <ul class="card_foot_list">
          <template v-if="abnormalSchoolList.length">
            <li
              v-for="(item, index) in abnormalSchoolList"
              :key="'abnormal' + index"
              @click="toAbnormalDetail(item)"
            >
              {{
                org_type == "2" || isSchool ? item.course_name : item.orga_name
              }}（{{ item.abnormal_num }}次）
            </li>
          </template>
          <p v-else style="color: #9b9b9b">暂无异常评价数据</p>
        </ul>
      </div>
    </div>
    <el-dialog
			:title="dialog_title"
			:visible.sync="dialog_show"
			custom-class="delDialog"
			:append-to-body="true"
      width="400px"
      :show-close='false'
      center
		>
			<div v-html="dialog_content" style="font-size: 14px;line-height: 22px;color: #555555;"></div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" size="small" @click="dialog_show=false">我知道了</el-button>
			</div>
		</el-dialog>
    </div>
    <div class="detail" v-if="isDetail">
      <detail :initParams ="selecTopParams" @back="back" :initType="initType" :evaTab="tabVal"></detail>
    </div>
  </div>
</template>
<script>
import selectControl from "./selectControl.vue";
import detail from "./detail.vue"
import { handleParticipation } from "@/api/education/homeApi.js";
import * as echarts from "echarts";
import "echarts-liquidfill";
import dayjs from "dayjs";
import util from "@/utils/util.js";
import { mapMutations, mapState } from "vuex";
import cloudMapApi from "@/api/cloudMapApi.js";
export default {
  props: ["info"],
  components: { selectControl ,detail},
  data() {
    return {
      isTestUser:(JSON.parse(sessionStorage.userInfo).user_id=='0683f7b06e0811eca8a8020315d352ba' || JSON.parse(sessionStorage.userInfo).user_id=='fb01b294655e11ecaada0203151a1abe'),
      isDetail:false,//区分是否为内页
      initType:{},//进入内页类型
      userInfo: JSON.parse(sessionStorage.userInfo || "{}"), //用户信息
      strokeWidth: 13,
      time_start: new Date(
        new Date(new Date().toLocaleDateString()).getTime() -
          24 * 60 * 60 * 1000
      ),
      time_end: new Date(
        new Date(new Date().toLocaleDateString()).getTime() -
          24 * 60 * 60 * 1000
      ),
      org_type: sessionStorage.org_type, // 1:教育局, 2:学校, 8:机构
      user_level: sessionStorage.user_level, // 教育局级别判断	省级:99  市级:1,10  区县级:2,20,4,40
      semesterOption: [
        { text: "2021-2022学年上学期", value: "2021-2022学年上学期" },
        { text: "2021-2022学年下学期", value: "2021-2022学年下学期" },
        { text: "2022-2023学年上学期", value: "2022-2023学年上学期" },
        { text: "2022-2023学年下学期", value: "2022-2023学年下学期" },
        { text: "2022-2024学年上学期", value: "2022-2024学年上学期" },
        { text: "2022-2024学年下学期", value: "2022-2024学年下学期" },
      ], //校级学期选择
      sch_sup: 0, // 提供课后服务学校总数
      sch_sup_per: 0, // 提供课后服务学校占比
      sch_time_std: 0, // 服务时间达标学校总数
      sch_time_std_per: 0, // 服务时间达标学校占比
      sch_course_std: 0, // 课程安排达标学校总数
      sch_course_std_per: 0, // 课程安排达标学校占比
      wdb_1: 0, // 未提供课后服务学校总数
      wdb_2: 0, // 服务时间未达标学校总数
      wdb_3: 0, // 课程安排未达标学校总数
      showSchoolPart: false,
      detailType:'',//传入的内页类型
      schoolPart_type: "one",
      showCourseClasses: false, //显示学校开班明细弹框
      teacherAttendanceParams: {
        start_date: "",
        end_date: "",
      }, //师生出勤率统计请求参数
      selecTopParams: {
        pagenum: 1,
        pagesize: 10,
        topic: "",
        yearly_semester: "2023-2024学年上学期",
      }, //头部区级切换参数
      teacherAttendanceList: [
        {
          tea_attendance_per: 0, //设置初始值解决el-progress值不能为空问题
          tea_actual_num: 0,
          stu_attendance_per: 0,
          stu_actual_num: 0,
        },
      ], //师生出勤率统计
      schoolCourseData: [
        {
          course_sum: 0,
          course_sum_per: 0,
          course_sum_ext_per: 0,
          course_sum_ext: 0,
        },
      ], //学校开课情况
      courseStartData: [
        {
          class_total: 0,
        },
      ], //课程开班情况
      teacherActorData: [
        {
          org_num: 0,
          org_per: 0,
          ext_org_num: 0,
          main_per: 0,
        },
      ], //教师参与整体情况
      time_show: false,
      type: "city",
      dateTime: "", //当前查询的时间
      tabVal: 1,
      timeText: false,
      tabtList: [
        { lable: "昨天", val: 1 },
        { lable: "近7日", val: 7 },
        { lable: "近30日", val: 30 },
      ],
      tabVal_1: 7,
      tabtList_1: [
        { lable: "近7日", val: 7 },
        { lable: "近30日", val: 30 },
      ],
      echartXData1: [],
      echartXData2: [],
      teacherJionTypes: [], //教师参与明细表切换数据
      courseStartTypes: [], //课程开班明细表切换数据
      teacherYData: [], //教师参与情况Y轴数据
      openClassData: [],
      courseOpenData: [],
      courseContentEvaluate: [
        { value: 8, name: "5星" },
        { value: 24, name: "4星" },
        { value: 34, name: "3星" },
        { value: 13, name: "2星" },
        { value: 55, name: "1星" },
      ],
      courseTeacherEvaluate: [
        { value: 11, name: "5星" },
        { value: 21, name: "4星" },
        { value: 14, name: "3星" },
        { value: 10, name: "2星" },
        { value: 22, name: "1星" },
      ],
      course_eva_content: [], // 课程内容
      course_eva_harvest: [], // 学生收获
      course_eva_performance: [], // 教师表现
      course_eva_attitude: [], // 教学态度
      abnormalSchoolList: [],
      select_name: "", // 选择器显示
      showCourseAbnormal: false,
      abnormal_name: "",
      abnormal_course_name: "",
      abnormal_course_id: "",
      abnormal_num: 0,
      abnormal_org_id: "", // 异常评价学校id
      participate_stu_num: 0, // 参与课后服务学生总数
      participate_stu_per: 0, // 参与课后服务学生占比
      stduentJionData: [
        { value: 0, name: "未参与" },
        { value: 0, name: "全时参与" },
        { value: 0, name: "部分时间参与" },
      ],
      student_participate_title: [], // 各类课程学生参与情况-标题文字
      student_participate_num: [], // 各类课程学生参与情况-数据
      studentPart_type: "one", // one: 学生参与明细表, two: 各类课程学生参与明细表
      showStudentPart: false,
      alertArray: [
        {
          title: "师生出勤率情况说明",
          message:
            "教师出勤率：当前学期，教师实际出勤总人次÷教师应出勤总人次<p style='height:15px'></p>学生出勤率：当前学期，学生实际出勤总人次÷学生应出勤总人次",
        },
        {
          title: "教师参与情况说明",
          message: "校内教师任教了课后服务课程，则认为参与了课后服务",
        },
        {
          title: "学生参与情况说明",
          message:
            "全时参与：当前学期任一周满足周一至周五都报名了课后服务课程即认为全时参与 <p style='height:15px'></p>部分时间参与：报名了课后服务课程，但未达到全时参与的标准，则为部分时间参与 \n未参与：未报名任何课后服务课程",
        },
        {
          title: "学校开课情况说明",
          message:
            "校内教师课程数：当前学期，课后服务课程授课教师为校内教师的数量 <p style='height:15px'></p>校外教师课程数：当前学期，课后服务课程授课教师为校外教师的数量",
        },
        {
          title: "课程开班情况说明",
          message: "课程开班数：当前学期，课后服务课程开设班级数",
        },
        {
          title: "课程评价情况说明",
          message:
            "异常评价：评价为1星或2星的，即为异常评价，可点击查看具体评价内容",
        },
      ], //弹出提示框
      dialog_title:'',
      dialog_content:'',
      dialog_show: false,
      detailTitle:'学校参与情况'
    };
  },
  computed: {
    ...mapState(["isSchool"]),
    text() {
      return this.currentRate + "所" + "" + this.currentRate.toFixed(0) + "%";
    },
    show_select_name() {
      let str = this.selecTopParams.yearly_semester + "　" + this.select_name;
      if (this.selecTopParams.prd_name) {
        str = str + "　" + this.selecTopParams.prd_name;
      }
      return str;
    },
    startDate: function () {
      if (this.time_start) {
        return this.dayjs(this.time_start).format("YYYY-MM-DD");
      }
      this.time_start = this.dayjs().format("YYYY-MM-DD");
      return this.dayjs().format("YYYY-MM-DD");
    },
    endDate: function () {
      if (this.time_end) {
        return this.dayjs(this.time_end).format("YYYY-MM-DD");
      }
      this.time_end = this.dayjs().format("YYYY-MM-DD");
      return this.dayjs().format("YYYY-MM-DD");
    },
    end_minDate() {
      if (this.time_start) {
        // if (this.isIOS()) {
        //   this.item.start = this.item.start.replace('-', '/');
        // }
        return new Date(
          this.dayjs(this.time_start).format("YYYY/MM/DD HH:mm:ss")
        );
      }
      return new Date();
    },
  },
  watch: {
    tabVal(n, o) {
      this.getAbnormalAppraise();
    },
    tabVal_1(n, o) {
      this.teacherAttendanceParams.end_date = this.dayjs(
        this.getDayDate(0)
      ).format("YYYY-MM-DD");
      if (n === 7) {
        this.teacherAttendanceParams.start_date = this.dayjs(
          this.getDayDate(7)
        ).format("YYYY-MM-DD");
      } else {
        this.teacherAttendanceParams.start_date = this.dayjs(
          this.getDayDate(30)
        ).format("YYYY-MM-DD");
      }
      this.getTeacherAttendance();
    },
  },
  mounted() {

  },
  created() {
    this.updateIsSchool(false);
    this.teacherAttendanceParams.end_date = this.dayjs(
      this.getDayDate(0)
    ).format("YYYY-MM-DD");
    this.teacherAttendanceParams.start_date = this.dayjs(
      this.getDayDate(7)
    ).format("YYYY-MM-DD");
    this.initData();
    this.getNowDate();
    this.getData();
  },
  methods: {
    ...mapMutations(["updateIsSchool"]),
    dayjs,
    seeInfo(api,title){
      let allParams = {
        selecTopParams:this.selecTopParams,
        initParams:{
          detailTitle:title,
          detailType:api
        }
      }
      this.isDetail = true
      this.initType = {
          detailTitle:title,
          detailType:api
      }
    },
    back(){
      this.isDetail = false
    },
    getDayDate(num) {
      let date = new Date(
        new Date(new Date().toLocaleDateString()).getTime() -
          num * 24 * 60 * 60 * 1000
      );
      return date;
    },
    // 初始化参数
    initData() {
      console.log("用户", this.userInfo, this.org_type, this.user_level,);
      this.selecTopParams = {
        pagenum: 1,
        pagesize: 10,
        topic: "",
        yearly_semester:util.getYearlySemester()|| "2023-2024学年上学期",
      };
      if (this.org_type == "1" || this.org_type === "4") {
        if (this.user_level === "99") {
          // 省级
          this.selecTopParams.topic = "省";
          this.selecTopParams.prov_code = this.userInfo.province_code;
          this.select_name = this.userInfo.province_name || "全省";
        } else if (["1", "10"].indexOf(this.user_level) > -1) {
          // 市级
          this.selecTopParams.topic = "市";
          this.selecTopParams.city_code = this.userInfo.city_code;
          this.select_name = this.userInfo.city_name || "全市";
        } else if (["2", "20", "4", "40"]) {
          // 区级
          this.selecTopParams.topic = "区";
          this.selecTopParams.coun_code = this.userInfo.area_code;
          this.select_name = this.userInfo.area_name || "全区";
        }
      } else if (this.org_type == "2") {
        this.selecTopParams.topic = "校";
        this.selecTopParams.orga_id = sessionStorage.orgId;
        this.select_name = this.userInfo.last_top_org_name;
      }
    },
    fixed2(value) {
      let percentage = (value * 100).toFixed(2) * 1 + "%";
      return percentage;
    },
    // 获取图表接口数据
    getData() {
      this.schoolParticipate();
      this.getSchoolCourseData();
      this.getTeacherAttendance();
      this.getCourseStartData();
      this.getTeacherActor();
      this.getallCourseTeacher();
      this.getStudentParticipate();
      this.getAbnormalAppraise();
      this.getCourseAppraise();
    },
    //校级账号切换左上角
    semesterOptionChange(e) {
      this.selecTopParams.yearly_semester = e;
      // this.getSchoolCourseData(); //获取学校开课情况
      // this.getTeacherAttendance();
      // this.getCourseStartData(); //获取课程开班情况
      // this.getTeacherActor();
      this.getData();
    },
    //学校参与情况
    async schoolParticipate() {
      let api = "";
      if (this.org_type == "2" || this.isSchool) {
        // 学校
        api = "afterClassSchool";
      } else {
        // 教育局
        api = "afterClass";
      }
      let res = await cloudMapApi[api](this.selecTopParams);
      if (res.code == "0" && res.data.rows.length > 0) {
        if (this.org_type == "2" || this.isSchool) {
          // 学校
          this.sch_time_std = res.data.rows[0].cls_time_num || 0;
          this.sch_time_std_per =
            (res.data.rows[0].cls_time_num_per || 0) * 100;
          this.sch_course_std = res.data.rows[0].cls_course_num || 0;
          this.sch_course_std_per =
            (res.data.rows[0].cls_course_num_per || 0) * 100;
          this.wdb_2 = res.data.rows[0].cls_time_ef_num || 0;
          this.wdb_3 = res.data.rows[0].cls_course_ef_num || 0;
        } else {
          this.sch_sup = res.data.rows[0].sch_sup || 0;
          this.sch_sup_per = (res.data.rows[0].sch_sup_per || 0) * 100;
          this.sch_time_std = res.data.rows[0].sch_time_std || 0;
          this.sch_time_std_per =
            (res.data.rows[0].sch_time_std_per || 0) * 100;
          this.sch_course_std = res.data.rows[0].sch_course_std || 0;
          this.sch_course_std_per =
            (res.data.rows[0].sch_course_std_per || 0) * 100;
          this.wdb_1 = res.data.rows[0].sch_sup_ef || 0;
          this.wdb_2 = res.data.rows[0].sch_time_std_ef || 0;
          this.wdb_3 = res.data.rows[0].sch_course_std_ef || 0;
        }
      } else {
        this.sch_sup = 0;
        this.sch_sup_per = 0;
        this.sch_time_std = 0;
        this.sch_time_std_per = 0;
        this.sch_course_std = 0;
        this.sch_course_std_per = 0;
        this.wdb_1 = 0;
        this.wdb_2 = 0;
        this.wdb_3 = 0;
      }
    },
    clickSchoolPart(type) {
      this.schoolPart_type = type;
      this.showSchoolPart = true;
    },
    showShoolCourse() {
      this.showCourseClasses = true;
    },
    //学校开课情况
    async getSchoolCourseData() {
      let res = await cloudMapApi.shoolStartCourse(this.selecTopParams);
      if (res.data.rows.length > 0) {
        this.schoolCourseData = res.data.rows;
        this.openClassData = [
          {
            value: this.schoolCourseData[0].course_sum,
            name: "校内教师课程数",
          },
          {
            value: this.schoolCourseData[0].course_sum_ext,
            name: "校外教师课程数",
          },
        ];
      } else {
        this.schoolCourseData = [
          {
            course_sum: 0,
            course_sum_per: 0,
            course_sum_ext_per: 0,
            course_sum_ext: 0,
          },
        ];
        this.openClassData = [
          { value: 0, name: "校内教师课程数" },
          { value: 0, name: "校外教师课程数" },
        ];
      }

      this.init(); //重新渲染eacharts
    },
    async getCourseStartData() {
      let res = await cloudMapApi.courseStart(this.selecTopParams);
      this.courseOpenData = [];
      this.courseStartData = [];
      if (res.data.rows.length > 0) {
        this.courseStartData = res.data.rows;
        let tables = [];
        this.courseStartData.map((item) => {
          this.courseOpenData.push({
            value: item.class_sum,
            name: item.type_name,
          });
          tables.push({
            value: item.type_name,
            key: item.type_name,
          });
        });
        this.courseStartTypes = tables;
      }
      console.log(this.courseStartData, "请求成功wwwwwwwwwwwwwwwwwww");
      this.init();
    },
    //教师参与整体情况
    async getTeacherActor() {
      let res = await cloudMapApi.teacherActor(this.selecTopParams);
      if (res.data.rows.length > 0) {
        this.teacherActorData = res.data.rows;
        console.log('考勤++++++++',res)
      } else {
        this.teacherActorData = [
          {
            org_num: 0,
            org_per: 0,
            ext_org_num: 0,
            ext_org_per: 0,
          },
        ];
      }
    },
    //各类课程教师参数总体情况
    async getallCourseTeacher() {
      let res = await cloudMapApi.allCourseTeacher(this.selecTopParams);
      if (res.data.rows.length > 0) {
        let YData = [];
        let xData1 = [];
        let xData2 = [];
        let tables = [];
        res.data.rows.map((item) => {
          xData1.push(item.org_num);
          xData2.push(item.ext_org_num);
          YData.push(item.type_name);
          tables.push({
            value: item.type_name,
            key: item.type_name,
          });
        });
        this.echartXData1 = xData1;
        this.echartXData2 = xData2;
        this.teacherYData = YData;
        this.teacherJionTypes = tables;
      } else {
        this.echartXData1 = [];
        this.echartXData2 = [];
        this.teacherYData = [];
        this.teacherJionTypes = [];
      }
      this.init();
    },
    // 课程评价统计
    async getCourseAppraise() {
      try {
        let res = await cloudMapApi.courseAppraise(this.selecTopParams);
        console.log("课程评价统计---", res);
        if (res.code == "0") {
          let list = res.data.rows;
          this.course_eva_content = list.map((e) => {
            return {
              name: e.star_stage,
              value: e.course_content || 0,
            };
          });
          this.course_eva_harvest = list.map((e) => {
            return {
              name: e.star_stage,
              value: e.students_gain || 0,
            };
          });
          this.course_eva_performance = list.map((e) => {
            return {
              name: e.star_stage,
              value: e.teacher_performance || 0,
            };
          });
          this.course_eva_attitude = list.map((e) => {
            return {
              name: e.star_stage,
              value: e.teaching_attitude || 0,
            };
          });
          this.init_CourseApprais();
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 异常评价预警
    async getAbnormalAppraise() {
      try {
        let params = {
          date: this.tabVal,
          ...JSON.parse(JSON.stringify(this.selecTopParams)),
        };
        params.topic = params.topic === "校" ? "课程" : "学校";
        params.pagesize = 4;
        let res = await cloudMapApi.abnormalAppraise(params);
        if (res.code == "0") {
          this.abnormalSchoolList = res.data.rows;
        }
      } catch (err) {
        console.log(err);
      }
    },
    toAbnormalDetail(item) {
      this.abnormal_name = item.orga_name;
      this.abnormal_num = item.abnormal_num;
      this.abnormal_org_id = item.orga_id;
      if (this.selecTopParams.topic == "校") {
        this.abnormal_course_name = item.course_name;
        this.abnormal_course_id = item.course_id;
      } else {
        this.abnormal_course_name = "";
        this.abnormal_course_id = "";
      }
      this.showCourseAbnormal = true;
    },
    // 删除对象空值key
    removeProperty(obj) {
      Object.keys(obj).forEach((item) => {
        if (
          obj[item] === "" ||
          obj[item] === undefined ||
          obj[item] === null ||
          obj[item] === "null" ||
          (obj[item] && !obj[item].length)
        )
          delete obj[item];
      });
      return obj;
    },
    selectOk(e) {
      console.log(e);
      this.updateIsSchool(false);
      if(this.org_type=='2'){
        this.selecTopParams = {
          pagenum: 1,
          pagesize: 10,
          topic: "校",
          orga_id: sessionStorage.orgId,
          yearly_semester: e.yearly_semester,
        };
        this.getData();
        return;
      }
      this.selecTopParams = {
        pagenum: 1,
        pagesize: 10,
        topic: "",
        yearly_semester:util.getYearlySemester() || "2023-2024学年上学期",
      };
      if (e.prov_name) {
        this.select_name = e.prov_name;
        this.selecTopParams.topic = "省";
      } else if (e.city_name) {
        this.select_name = e.city_name;
        this.selecTopParams.topic = "市";
      } else if (e.coun_name) {
        this.select_name = e.coun_name;
        this.selecTopParams.topic = "区";
      } else if (e.orga_name) {
        this.select_name = e.orga_name;
        this.selecTopParams.topic = "校";
        this.updateIsSchool(true);
      } else {
        if (this.org_type != "2") {
          if (this.user_level === "99") {
            // 省级
            this.selecTopParams.topic = "省";
            this.selecTopParams.prov_code = this.userInfo.province_code;
            this.select_name = this.userInfo.province_name || "全省";
          } else if (["1", "10"].indexOf(this.user_level) > -1) {
            // 市级
            this.selecTopParams.topic = "市";
            this.selecTopParams.city_code = this.userInfo.city_code;
            this.select_name = this.userInfo.city_name || "全市";
          } else if (["2", "20", "4", "40"]) {
            // 区级
            this.selecTopParams.topic = "区";
            this.selecTopParams.coun_code = this.userInfo.area_code;
            this.select_name = this.userInfo.area_name || "全区";
          }
        }
      }
      delete e["qy"];
      if (e["prd_name"] === "全学段") {
        delete e["prd_id"];
        delete e["prd_name"];
      }
      this.removeProperty(e);
      Object.assign(this.selecTopParams, e);
      console.log("筛选", this.selecTopParams);
      // this.updateLoadingStatus({ show: true });
      // 师生出勤统计筛选参数初始化
      this.teacherAttendanceParams = {
        start_date: "",
        end_date: "",
      };
      this.teacherAttendanceParams.end_date = this.dayjs(
        this.getDayDate(0)
      ).format("YYYY-MM-DD");
      if (this.tabVal_1 === 7) {
        this.teacherAttendanceParams.start_date = this.dayjs(
          this.getDayDate(7)
        ).format("YYYY-MM-DD");
      } else {
        this.teacherAttendanceParams.start_date = this.dayjs(
          this.getDayDate(30)
        ).format("YYYY-MM-DD");
      }
      this.getData();
    },
    //师生考勤情况
    async getTeacherAttendance() {
      // if (this.startDate) {
      //   this.teacherAttendanceParams.start_date = this.startDate;
      // }
      // if (this.endDate) {
      //   this.teacherAttendanceParams.end_date = this.endDate;
      // }
      Object.assign(this.teacherAttendanceParams, this.selecTopParams);
      let res = await cloudMapApi.getTeacherAttendance(
        this.teacherAttendanceParams
      );
      if (res.data.rows.length > 0) {
        this.teacherAttendanceList = res.data.rows;
      } else {
        this.teacherAttendanceList = [
          {
            tea_attendance_per: 0,
            tea_actual_num: 0,
            stu_attendance_per: 0,
            stu_actual_num: 0,
          },
        ];
      }
      this.init_teacher_att();
    },
    init_teacher_att() {
      let vm = this;
      vm.$nextTick(() => {
        // 水球显示教师出勤率
        let chartDom1 = document.getElementById("chartDom1");
        let myChart1 = echarts.init(chartDom1);
        let option1 = {
          series: [
            {
              type: "liquidFill",
              name: "Liquid Fill",
              radius: "70%",
              itemStyle: {
                opacity: 0.55,
              },
              data: [
                {
                  name: "score",
                  direction: "right",
                  value:this.isTestUser?0.5984:
                    this.teacherAttendanceList[0].tea_attendance_per.toFixed(
                      2
                    ) * 1,
                  itemStyle: {
                    opacity: 0.55,
                    normal: {
                      color: "#A3E0FB",
                    },
                  },
                },
                {
                  name: "scores",
                  direction: "right",
                  value:this.isTestUser?0.5984:
                    this.teacherAttendanceList[0].tea_attendance_per.toFixed(
                      2
                    ) *
                      1 +
                    0.01, //增加波纹的效果A3E0FB
                  itemStyle: {
                    opacity: 0.55,
                    normal: {
                      color: "#02ABF3",
                    },
                  },
                },
                // {
                //   name: "scorex",
                //   direction: "right",
                //   value: 0.45,
                //   itemStyle: {
                //     opacity: 0.55,
                //     normal: {
                //       // color: 'red'
                //     },
                //   },
                // },
              ],
              backgroundStyle: {
                // 设置水球图内部背景色
                borderColor: "#02ABF3",
                borderWidth: 1.5,
                color: "white", //水球图内部背景色
              },
              itemStyle: {
                opacity: 0.55,
                shadowBlur: 50,
                shadowColor: 'rgba(0, 0, 0, 0)',
              },
              label: {
                // 设置百分比展示
                color: "#02ABF3",
                normal: {
                  textStyle: {
                    fontSize: 20,
                    fontWeight: 400,
                    // color: '#fff',
                  },
                  formatter: function (param) {
                    return vm.isTestUser?"59.84%": (vm.teacherAttendanceList[0].tea_attendance_per* 100).toFixed(2)+ "%"
                  },
                },
              },
              outline: {
                // 是否显示外圈
                show: false,
              },
            },
          ],
        };
        myChart1.setOption(option1);
        // 水球显示学生出勤率
        let chartDom2 = document.getElementById("chartDom2");
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          series: [
            {
              type: "liquidFill",
              name: "Liquid Fill",
              radius: "70%",
              itemStyle: {
                opacity: 0.55,
              },
              data: [
                {
                  name: "score",
                  direction: "right",
                  value:this.isTestUser?0.51:
                    this.teacherAttendanceList[0].stu_attendance_per.toFixed(
                      4
                    ) * 1,
                  itemStyle: {
                    opacity: 0.55,
                    normal: {
                      color: "#C7F5C9",
                    },
                  },
                },
                {
                  name: "scores",
                  direction: "right",
                  value:this.isTestUser?0.51:
                    this.teacherAttendanceList[0].stu_attendance_per.toFixed(
                      4
                    ) *
                      1 +
                    0.01, //增加波纹的效果C7F5C9
                  itemStyle: {
                    opacity: 0.55,
                    normal: {
                      color: "#40DB46",
                    },
                  },
                },
                // {
                //   name: "scorex",
                //   direction: "right",
                //   value: 0.45,
                //   itemStyle: {
                //     opacity: 0.55,
                //     normal: {
                //       // color: 'red'
                //     },
                //   },
                // },
              ],
              backgroundStyle: {
                // 设置水球图内部背景色
                borderColor: "#40DB46",
                borderWidth: 1.5,
                color: "white", //水球图内部背景色
              },
              itemStyle: {
                opacity: 0.55,
                shadowBlur: 50,
                shadowColor: 'rgba(0, 0, 0, 0)',
              },
              label: {
                // 设置百分比展示
                color: "#40DB46",
                normal: {
                  textStyle: {
                    fontSize: 20,
                    fontWeight: 400,
                    // color: '#fff',
                  },
                  formatter: function (param) {
                    return vm.isTestUser?"51.78%" : (vm.teacherAttendanceList[0].stu_attendance_per* 100).toFixed(2) + "%"   ;
                  },
                },
              },
              outline: {
                // 是否显示外圈
                show: false,
              },
            },
          ],
        };
        console.log('席巴',  )
        myChart2.setOption(option2);
      });
    },
    redClick(title, isOne) {
      if (isOne) {
        let message =
          isOne == '2' || this.isSchool
            ? "服务时间(5+2)达标班级：<p style='height:15px'></p>行政班的学生可报名的课后服务课程，覆盖了每个工作日且覆盖课节时长均达到2小时的班级，即认为达标<p style='height:15px'></p> 服务时间(1+X)达标班级：<p style='height:15px'></p>小学：行政班的学生可报名的课后服务课程，既包含了作业辅导答疑课也包含了校内活动课程，即认为达标\n初中：行政班的学生可报名作业辅导答疑课，即认为达标"
            : "提供课后服务学校：当前学期创建了选课安排并生成了课表的学校即认为提供了课后服务<p style='height:15px'></p>服务时间(5+2)达标学校：当前学期学校提供的课后服务课程满足一周5天，每天2小时，即认为达标<p style='height:15px'></p>课程安排(1+X)达标学校：当前学期学校提供的课后服务课程既包含作业辅导答疑，也包含校内活动课程。（初中学段，对校内活动课程不做要求）";
        this.dialog_title = title;
        this.dialog_content = message;
        this.dialog_show = true;
      } else {
        console.log(title);
        let findtext = this.alertArray.find((item) => {
          return item.title == title;
        });
        this.dialog_title = findtext.title;
        this.dialog_content = findtext.message;
        this.dialog_show = true;
      }
    },
    tabClick(item) {
      this.tabVal = item.val;
    },
    tabClick_1(item) {
      this.tabVal_1 = item.val;
    },
    onConfirm() {
      if (this.startDate) {
        this.teacherAttendanceParams.start_date = this.startDate;
        if (this.startDate > this.endDate) {
          this.$toast("开始时间不能大于结束时间！");
          this.teacherAttendanceParams.start_date = this.endDate;
        } else {
          this.getTeacherAttendance();
          this.time_show = false;
          this.timeText = true;
        }
      }
      if (this.endDate) {
        this.teacherAttendanceParams.end_date = this.endDate;
      }
      console.log("时间", this.startDate, this.endDate);
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    //初始化echarts图表
    init() {
      let vm = this;
      vm.$nextTick(() => {
        // 柱状图 - 各类课程教师参与情况
        let chartDom3 = document.getElementById("chartDom3");
        let myChart3 = echarts.init(chartDom3);
        let option3 = {
          barWidth: 14, // 柱子宽度
          tooltip: {
            show: false,
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          legend: {
            right: 20,
            icon: "circle",
          },
          grid: {
            top: "8%",
            left: "0",
            right: "10%",
            bottom: "5%",
            containLabel: true,
          },
          xAxis: {
            show: false,
            // type: 'value',
            // boundaryGap: [0, 0.01]
          },
          yAxis: {
            //  y轴刻度线
            axisLine: { show: false },
            // 是否显示坐标轴刻度
            axisTick: {
              show: false,
            },
            // 去掉网格线
            // splitLine: {
            //   show: false
            // },
            // splitArea: {
            //   show: false
            // },
            type: "category",
            data: this.teacherYData,
          },
          series: [
            {
              name: "校内教师",
              type: "bar",
              data: this.echartXData1,
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: "#4CA7FB" },
                  ]),
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "right",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999",
                    },
                  },
                },
              },
              // barWidth: 10, //设置柱子宽度，单位为px
            },
            {
              name: "校外教师",
              type: "bar",
              data: this.echartXData2,
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: "#66CB70" },
                  ]),
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "right",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999",
                    },
                  },
                },
              },
              // barWidth: 10, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart3.setOption(option3);

        // 饼形图- 学校开课情况
        let chartDom6 = document.getElementById("chartDom6");
        let myChart6 = echarts.init(chartDom6);
        let option6 = {
          tooltip: {
            trigger: "item",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
            formatter:
              '<strong> {b0}:</strong> <span style="display: inline-block;  border-radius: 10px; width: 10px; height: 10px;"></span><strong>{c0}个</strong> <br />',
          },
          legend: {
            type: "scroll",
            orient: "vertical",
            right: 10,
            top: "center",
            bottom: 20,
            icon: "circle",
          },
          grid: {
            top: "2%",
            left: "0",
            right: "5%",
            bottom: "10%",
            containLabel: true,
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["40%", "60%"], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: "center",
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: "16",
                  fontWeight: "bold",
                },
              },
              labelLine: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              data: this.openClassData,
            },
          ],
          // 圆环颜色
          color: ["#FDA256", "#3592FF"],
        };
        myChart6.setOption(option6);

        // 饼形图- 课程开课情况
        let chartDom7 = document.getElementById("chartDom7");
        let myChart7 = echarts.init(chartDom7);
        let option7 = {
          tooltip: {
            trigger: "item",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
            formatter:
              '<strong> {b0}:</strong> <span style="display: inline-block;  border-radius: 10px; width: 10px; height: 10px;"></span><strong>{c0}个</strong> <br />',
          },
          legend: {
            type: "scroll",
            orient: "vertical",
            right: 10,
            top: "center",
            bottom: 20,
            icon: "circle",
          },
          grid: {
            top: "2%",
            left: "0",
            right: "5%",
            bottom: "10%",
            containLabel: true,
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["40%", "60%"], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: "center",
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: "16",
                  fontWeight: "bold",
                },
              },
              labelLine: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              data: this.courseOpenData,
            },
          ],
          // 圆环颜色
          color: [
            "#5D6ADB",
            "#5B8FF9",
            "#81AAFF",
            "#68DDCF",
            "#6DEC72",
            "#E9EC6D",
            "#FDA256",
            "#E8684A",
            "#9270CA",
          ],
        };
        myChart7.setOption(option7);
      });
    },
    clickStudentPart(type) {
      this.showStudentPart = true;
      this.studentPart_type = type;
    },
    // 课程评价图表
    init_CourseApprais() {
      let vm = this;
      vm.$nextTick(() => {
        // 饼形图- 课程内容
        let chartDom8 = document.getElementById("chartDom8");
        let myChart8 = echarts.init(chartDom8);
        let option8 = {
          title: {
            text: "", //主标题文本
            subtext: "课程评价",//"课程内容\n总体评价", //副标题文本
            left: "center",
            top: "35%",
            subtextStyle: {
              fontFamily: "微软雅黑",
              fontSize: 14,
              lineHeight: 20,
              color: "#000000",
            },
          },
          tooltip: {
            trigger: "item",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
            formatter:
              '<strong> {b0}:</strong> <span style="display: inline-block;  border-radius: 10px; width: 10px; height: 10px;"></span><strong>{c0}个</strong> <br />',
          },
          legend: {
            itemWidth: 12,
            itemHeight: 9,
            type: "scroll",
            orient: "vertical",
            right: 0,
            top: "center",
            bottom: 20,
          },
          grid: {
            top: "2%",
            left: "0",
            right: "5%",
            bottom: "10%",
            containLabel: true,
          },
          series: [
            {
              type: "pie",
              radius: ["60%", "50%"], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: "center",
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: "16",
                  fontWeight: "bold",
                },
              },
              labelLine: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              data: this.course_eva_content,
            },
          ],
          // 圆环颜色
          color: ["#5E9FFF", "#92CAFF", "#FFE5A2", "#FDA256", "#EC7070"],
        };
        myChart8.setOption(option8);

        // 学生收获
        // let chartDom9 = document.getElementById("chartDom9");
        // let myChart9 = echarts.init(chartDom9);
        // let option9 = {
        //   title: {
        //     text: "", //主标题文本
        //     subtext: "学生收获\n总体评价", //副标题文本
        //     left: "center",
        //     top: "30%",
        //     subtextStyle: {
        //       fontFamily: "微软雅黑",
        //       fontSize: 14,
        //       lineHeight: 20,
        //       color: "#000000",
        //     },
        //   },
        //   tooltip: {
        //     trigger: "item",
        //     axisPointer: {
        //       // Use axis to trigger tooltip
        //       type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
        //     },
        //     formatter:
        //       '<strong> {b0}:</strong> <span style="display: inline-block;  border-radius: 10px; width: 10px; height: 10px;"></span><strong>{c0}个</strong> <br />',
        //   },
        //   legend: {
        //     itemWidth: 12,
        //     itemHeight: 9,
        //     type: "scroll",
        //     orient: "vertical",
        //     right: 0,
        //     top: "center",
        //     bottom: 20,
        //   },
        //   grid: {
        //     top: "2%",
        //     left: "0",
        //     right: "5%",
        //     bottom: "10%",
        //     containLabel: true,
        //   },
        //   series: [
        //     {
        //       type: "pie",
        //       radius: ["60%", "50%"], // 这个属性修改环形宽度
        //       avoidLabelOverlap: false,
        //       label: {
        //         show: false,
        //         position: "center",
        //       },
        //       emphasis: {
        //         label: {
        //           show: false,
        //           fontSize: "16",
        //           fontWeight: "bold",
        //         },
        //       },
        //       labelLine: {
        //         show: false,
        //       },
        //       labelLine: {
        //         show: false,
        //       },
        //       data: this.course_eva_harvest,
        //     },
        //   ],
        //   // 圆环颜色
        //   color: ["#5E9FFF", "#92CAFF", "#FFE5A2", "#FDA256", "#EC7070"],
        // };
        // myChart9.setOption(option9);
        // 教师表现
        let chartDom10 = document.getElementById("chartDom10");
        let myChart10 = echarts.init(chartDom10);
        let option10 = {
          title: {
            text: "", //主标题文本
            subtext: "老师评价",//"教师表现 \n总体评价", //副标题文本
            left: "center",
            top: "35%",
            subtextStyle: {
              fontFamily: "微软雅黑",
              fontSize: 14,
              lineHeight: 20,
              color: "#000000",
            },
          },
          tooltip: {
            trigger: "item",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
            formatter:
              '<strong> {b0}:</strong> <span style="display: inline-block;  border-radius: 10px; width: 10px; height: 10px;"></span><strong>{c0}个</strong> <br />',
          },
          legend: {
            itemWidth: 12,
            itemHeight: 9,
            type: "scroll",
            orient: "vertical",
            right: 0,
            top: "center",
            bottom: 20,
          },
          grid: {
            top: "2%",
            left: "0",
            right: "5%",
            bottom: "10%",
            containLabel: true,
          },
          series: [
            {
              type: "pie",
              radius: ["60%", "50%"], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: "center",
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: "16",
                  fontWeight: "bold",
                },
              },
              labelLine: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              data: this.course_eva_performance,
            },
          ],
          // 圆环颜色
          color: ["#5E9FFF", "#92CAFF", "#FFE5A2", "#FDA256", "#EC7070"],
        };
        myChart10.setOption(option10);
        // 教学态度
        // let chartDom11 = document.getElementById("chartDom11");
        // let myChart11 = echarts.init(chartDom11);
        // let option11 = {
        //   title: {
        //     text: "", //主标题文本
        //     subtext: "教学态度 \n总体评价", //副标题文本
        //     left: "center",
        //     top: "30%",
        //     subtextStyle: {
        //       fontFamily: "微软雅黑",
        //       fontSize: 14,
        //       lineHeight: 20,
        //       color: "#000000",
        //     },
        //   },
        //   tooltip: {
        //     trigger: "item",
        //     axisPointer: {
        //       // Use axis to trigger tooltip
        //       type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
        //     },
        //     formatter:
        //       '<strong> {b0}:</strong> <span style="display: inline-block;  border-radius: 10px; width: 10px; height: 10px;"></span><strong>{c0}个</strong> <br />',
        //   },
        //   legend: {
        //     itemWidth: 12,
        //     itemHeight: 9,
        //     type: "scroll",
        //     orient: "vertical",
        //     right: 0,
        //     top: "center",
        //     bottom: 20,
        //   },
        //   grid: {
        //     top: "2%",
        //     left: "0",
        //     right: "5%",
        //     bottom: "10%",
        //     containLabel: true,
        //   },
        //   series: [
        //     {
        //       type: "pie",
        //       radius: ["60%", "50%"], // 这个属性修改环形宽度
        //       avoidLabelOverlap: false,
        //       label: {
        //         show: false,
        //         position: "center",
        //       },
        //       emphasis: {
        //         label: {
        //           show: false,
        //           fontSize: "16",
        //           fontWeight: "bold",
        //         },
        //       },
        //       labelLine: {
        //         show: false,
        //       },
        //       labelLine: {
        //         show: false,
        //       },
        //       data: this.course_eva_attitude,
        //     },
        //   ],
        //   // 圆环颜色
        //   color: ["#5E9FFF", "#92CAFF", "#FFE5A2", "#FDA256", "#EC7070"],
        // };
        // myChart11.setOption(option11);
      });
    },
    // 学生参与情况数据
    async getStudentParticipate() {
      let res = await cloudMapApi.studentParticipate(this.selecTopParams);
      if (res.code == "0" && res.data.rows.length) {
        this.participate_stu_num = res.data.rows[0].participate_stu_num || 0;
        this.participate_stu_per =
          res.data.rows[0].participate_stu_per * 100 || 0;
        this.stduentJionData[0].value =
          res.data.rows[0].participate_stu_ef_num || 0;
        this.stduentJionData[1].value = res.data.rows[0].full_time_stu_num || 0;
        this.stduentJionData[2].value = res.data.rows[0].part_time_stu_num || 0;
      } else {
        this.participate_stu_num = 0;
        this.participate_stu_per = 0;
        this.stduentJionData[0].value = 0;
        this.stduentJionData[1].value = 0;
        this.stduentJionData[2].value = 0;
      }
      let res1 = await cloudMapApi.studentParticipateDetail(
        this.selecTopParams
      );
      if (res1.code == "0" && res1.data.rows.length) {
        let list_1 = [],
          list_2 = [];
        res1.data.rows.forEach((e) => {
          if (e.type_name) {
            if (list_1.indexOf(e.type_name) == -1) {
              list_1.push(e.type_name);
              list_2.push(e.participate_stu_num || 0);
            } else {
              list_2[list_1.indexOf(e.type_name)] += e.participate_stu_num;
            }
          }
        });
        this.student_participate_title = list_1;
        this.student_participate_num = list_2;
      } else {
        this.student_participate_title = [];
        this.student_participate_num = [];
      }
      this.init_studentParticipate();
    },
    // 学生参与图表
    init_studentParticipate() {
      let vm = this;
      vm.$nextTick(() => {
        let chartDom4 = document.getElementById("chartDom4");
        let myChart4 = echarts.init(chartDom4);
        let option4 = {
          tooltip: {
            show: true,
            trigger: "item",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
            formatter:
              "<strong> {b0}</strong> <br /> <span></span><strong>{d}%</strong> ",   // {c0}个
          },
          legend: {
            left: "center",
            top: "bottom",
            type: "scroll",
            orient: "vertical",
            right: 0,
            bottom: 0,
            // icon: 'rect'
            icon: "circle",
          },
          grid: {
            top: "2%",
            left: "0",
            right: "5%",
            bottom: "5%",
            containLabel: true,
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["35%", "60%"], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              data: this.stduentJionData,
              center: ["50%", "40%"],
              label: {
                formatter: "{d}%",
                show: false,
              },
            },
          ],
          // 圆环颜色
          color: ["#FF6D5A", "#3592FF", "#FDA256"],
        };
        myChart4.setOption(option4);

        // 各类课程学生参与情况
        let chartDom5 = document.getElementById("chartDom5");
        let myChart5 = echarts.init(chartDom5);
        let option5 = {
          tooltip: {
            show: false,
            // trigger: 'axis',
            // axisPointer: {
            //   type: 'shadow',
            // },
          },
          barWidth: 14, // 柱子宽度
          grid: {
            top: "10%",
            left: "0",
            right: "5%",
            bottom: "0%",
            containLabel: true,
          },
          xAxis: {
            show: false,
            // type: 'value',
            // boundaryGap: [0, 0.01]
          },
          yAxis: {
            //  y轴刻度线
            axisLine: { show: false },
            // 是否显示坐标轴刻度
            axisTick: {
              show: false,
            },
            type: "category",
            data: this.student_participate_title,
          },
          series: [
            {
              type: "bar",
              data: this.student_participate_num,
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: "#4CA7FB" },
                  ]),
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "right",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999",
                    },
                  },
                },
              },
              // barWidth: 10, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart5.setOption(option5);
      });
    },
    // 获取当前一天的数据
    getNowDate() {
      this.dateTime = util.getNowDate();
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  padding: 30px;
  .header-item-title {
    margin-bottom: 20px;
    font-size: 18px;
    color: #333;
    display: flex;
    align-items: center;
    .time {
      // margin-left: 30%;
      width: 200px;
      color: #606266;
      font-size: 14px;
    }
  }
  .parts {
    width: 100%;
    margin-bottom: 20px;
    .parts-top {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 20px;
      .parts-top_title {
        margin-right: 10px;
        font-size: 20px;
        line-height: 28px;
        color: #333333;
      }
      img{
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
      .tab_select {
        display: inline-block;
        width: 160px;
        height: 30px;
        margin-left: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        div:nth-child(1) {
          border-radius: 18px 0 0 18px;
        }
        div:nth-child(2) {
          border-radius: 0 18px 18px 0;
        }
        .res-tab {
          display: inline-block;
          width: 50%;
          height: 30px;
          line-height: 30px;
          border-radius: 18px;
          background: #fff;
          color: #0085ff;
          border: 1px solid #0085ff;
          text-align: center;
          cursor: pointer;
        }
        .on {
          width: 50%;
          border-radius: 18px;
          color: #fff;
          background: #0085ff;
          border: 1px solid #0085ff;
        }
      }
      .see_info {
        position: absolute;
        top: 0;
        right: 1%;
        cursor: pointer;
        font-size: 14px;
        color: #006ff1;
      }
    }
    .parts-content-box {
      width: 100%;
      display: flex;
      .parts-content {
        width: 33%;
        background: #ffffff;
        box-shadow: 0px 0px 14px rgba(207, 207, 207, 0.3);
        border-radius: 12px;
        padding: 2%;
        .conent_title {
          display: flex;
          font-size: 14px;
          color: #666666;
          img {
            margin-right: 10px;
          }
        }
        .conent_box {
          position: relative;
          margin: auto;
          margin-left: 10%;
          display: flex;
          align-items: center;
          justify-content: space-around;
          .circle_text{
            position: absolute;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            color: #FFBE87;
            position: absolute;
            top: 58%;
            left: 62%;
            font-size: 14px;
          }
          .conent_box_text{
            div{
              font-weight: bold;
              font-size: 28px;
              line-height: 39px;
              text-align: center;
              color: #000000;
            }
            p{
              margin-top: 10px;
              font-size: 14px;
              line-height: 20px;
              text-align: center;
              letter-spacing: -0.14px;
              color: rgba(155, 155, 155, 0.8);
            }
          }
          .circle_pro {
            position: absolute;
            top: 33% !important;
            left: 11%;
            font-size: 14px;
            color: #fda256;
          }
          .circle_1 {
            margin: 20px 10px 10px 0;
          }
          .circle_1 /deep/ svg > path:nth-child(2) {
            stroke: #fda256;
          }
          .circle_1 /deep/ .el-progress-circle__track {
            stroke: #fda256;
            opacity: 0.2;
          }
          .circle_1 /deep/ .el-progress__text {
            margin-top: -5%;
            color: #fda256;
            font-weight: bold;
          }
        }
      }
      .parts-content-left {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        width: 50%;
        margin-right: 3%;

        &.shadow {
          background: #ffffff;
          box-shadow: 0px 0px 14px rgba(207, 207, 207, 0.3);
          border-radius: 12px;
        }
        .parts-info-item {
          width: 50%;
          text-align: center;
          margin: 5% 0;
          p:nth-child(1) {
            font-weight: 600;
            font-size: 28px;
            color: #000000;
            margin-bottom: 10px;
          }
          p:nth-child(2) {
            font-size: 14px;
            color: rgba(155, 155, 155, 0.8);
          }
        }
        .content_box_left {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          width: 50%;
          height: 100%;
          background: #ffffff;
          box-shadow: 0px 0px 14px rgba(207, 207, 207, 0.3);
          border-radius: 12px;
          div {
            width: 100%;
            padding: 10%;
            text-align: center;
            p:nth-child(1) {
              font-weight: 600;
              font-size: 28px;
              color: #000000;
              margin-bottom: 10px;
            }
            p:nth-child(2) {
              font-size: 14px;
              color: rgba(155, 155, 155, 0.8);
            }
          }
        }
        .content_box_right {
          width: 50%;
          height: 100%;
        }
      }
      .parts-content-right {
        position: relative;
        width: 50%;
        p {
          position: absolute;
          top: 0.5%;
          left: 35%;
        }
      }
      .parts-content-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 50%;
        padding: 2.8% 10%;
        background: #ffffff;
        box-shadow: 0px 0px 14px rgba(207, 207, 207, 0.3);
        border-radius: 12px;
        .parts-content-item-left {
          // margin-right: 20%;
          p:nth-child(1) {
            font-weight: 600;
            font-size: 28px;
            color: #000000;
            margin-bottom: 10px;
          }
          p:nth-child(2) {
            font-size: 14px;
            color: rgba(155, 155, 155, 0.8);
          }
        }
        .parts-content-item-right {
          width: 120px;
          height: 120px;
        }
      }
      .echarts_box{
        width: calc(50% - 30px);
        height: 210px;
        padding:20px;
        background: #ffffff;
        box-shadow: 0px 0px 14px rgba(207, 207, 207, .3);
        border-radius: 12px;
      }
      .content_echarts_item {
        width: 80%;
        height: 165px;
      }
    }
    .warn_title {
      font-size: 12px;
      color: #000000;
      margin-right: 2%;
    }
    .warn_item {
      display: inline-block;
      cursor: pointer;
      font-size: 12px;
      color: #beddff;
      width: 66px;
      height: 30px;
      background: #eff7ff;
      border: 1px solid #beddff;
      border-radius: 24px;
      margin-right: 1%;
      color: #3997ff;
      text-align: center;
      line-height: 30px;
      &.on {
        background: #3997ff;
        color: #fff;
      }
    }
    .school_list {
      .card_foot_list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 20px 0px;
        color: #f3a5a5;
        li {
          width: 50%;
          margin-bottom: 10px;
        }
      }
    }
  }
}
::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #409eff;
  background: #ffffff;
}
::v-deep .el-radio-button .el-radio-button__inner {
  height: 32px;
  padding: 8px;
  color: #999999;
}
::v-deep .el-progress-circle {
  height: 88px !important;
  width: 88px !important;
}
</style>
